import { render, staticRenderFns } from "./shijian.vue?vue&type=template&id=4a263f5c&"
import script from "./shijian.vue?vue&type=script&lang=ts&"
export * from "./shijian.vue?vue&type=script&lang=ts&"
import style0 from "./shijian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports